export const VIDEO_RATIO_16_9 = 1.77777777;

export enum TemplateType {
  DIB = 'DIB',
  DIB_EXTENDED = 'DIB - EXTENDED',
  TIB = 'TIB',
  TIB_EXTENDED = 'TIB - EXTENDED',
  TITLE = 'TITLE',
  TITLE_EXTENDED = 'TITLE - EXTENDED',
  FOURSQ = '4SQ',
  FOURSQ_EXTENDED = '4SQ - EXTENDED',
  LEARNING = 'LEARNING',
  LEARNING_EXTENDED = 'LEARNING - EXTENDED',
  DIALOG = 'DIALOG',
  DIALOG_EXTENDED = 'DIALOG - EXTENDED',
  MC = 'MC',
  MC_EXTENDED = 'MC - EXTENDED',
  UNSCRAMBLE = 'UNSCRAMBLE',
  UNSCRAMBLE_EXTENDED = 'UNSCRAMBLE - EXTENDED',
  DND = 'DND',
  DND_EXTENDED = 'DND - EXTENDED',
  TAB = 'TAB',
  TAB_EXTENDED = 'TAB - EXTENDED',
}
